import { type ShippingAddressFields } from '@/types/productSelectionAndCheckout/types';
import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

export const trackFieldPrePopulatedEvents = (
  shippingAddressFields: ShippingAddressFields,
) => {
  const { city, state, zipCode: zipcode } = shippingAddressFields;

  if (city !== '') {
    trackEvent(AnalyticsEvent.FIELD_PRE_POPULATED, {
      city,
    });
  }

  if (state !== '') {
    trackEvent(AnalyticsEvent.FIELD_PRE_POPULATED, {
      state,
    });
  }

  if (zipcode !== '') {
    trackEvent(AnalyticsEvent.FIELD_PRE_POPULATED, {
      zipcode,
    });
  }
};
